import React from "react";
import HeroCarousel from "../components/HeroCarousel";
// import QuickLinks from "../components/QuickLinks_11_09_2026";
import { MarqueeTicker, NoticeBoard, ContactBoard } from "../components/NoticeBoard";
import { StatsBar, AboutSection, LeadershipSection } from "../components/AboutSection";
import { PartnerLogos } from "../components/PartnerLogos";
import NoticeModal from "../components/NoticeModal";
import BackToTopButton from "../components/BackToTopButton";   {/* add this */}
import "./Home.css";

export default function Home() {
  return (
    <main className="home">

      {/* Important Notice popup */}
      <NoticeModal />

      {/* Hero */}
      <HeroCarousel />

      {/* Stats (floats up, overlapping the hero) */}
      {/* <StatsBar /> */}

      {/* Scrolling ticker */}
      <MarqueeTicker />
    <div class="shadow1"></div>
  <AboutSection />
  
   
    <div className="clearfix"></div>
     <div class="shadow2"></div>
    <section className="leadership leadership-section">
        <div className="container">

         <LeadershipSection />

        </div>
      </section>

      <div class="clearfix"></div>
      {/* Quick Links + Notice Boards */}
      <section className="notices-section">
        <div className="container">

        

          {/* Top row: Quick Links (left) + Leadership (right) */}
          {/* <div className="grid-2"> */}
            
            
          {/* </div> */}

          {/* Bottom row: 3 notice boards */}
         <div className="section-eyebrow-row">
            {/* <p className="section-eyebrow">Explore MKCG</p> */}
            <h2 className="section-heading">Latest Updates</h2>
      <div className="border2"></div>
          </div>
          <div className="notices-grid mt-5">
            {/* <NoticeBoard endpoint="results"    title="Examination & Results" icon="📄" />
            <NoticeBoard endpoint="admissions" title="Student Admission"     icon="🎓" />
            <NoticeBoard endpoint="tenders"    title="Tenders"               icon="📑" /> */}

            <NoticeBoard endpoint="notices" title="Notices" icon="📢" />
            <NoticeBoard endpoint="recruitments" title="Advertisements" icon="📣"/> 
            <NoticeBoard endpoint="forms" title="Download Forms" icon="📥"/>
            <NoticeBoard endpoint="results" title="Examination & Results" icon="📄" />
            <NoticeBoard endpoint="admissions" title="Student Admission" icon="🎓"/>
            <NoticeBoard endpoint="tenders" title="Tenders" icon="📑"/>
            <NoticeBoard endpoint="mci" title="MCI Information" icon="🏥"/>
            <ContactBoard />
          </div>
     
        </div>
      </section> 
    <div class="shadow3"></div>


      {/* About */}
    

      {/* Affiliations / Partner Logos */}
	 
      <PartnerLogos />

      {/* Back to top button */}
      <BackToTopButton />
    </main>
  );
}